export const THOUGHTS_ON_DOGS: Record<ThoughtsOnDogsScreenNames, string> = {
	TOD_INTRO: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E1</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>
            <strong>INTRO</strong>
        </p>
        </div>
    `,

	E1: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>"I used to have a dog" - Selected</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E2</td>
            </tr>
            <tr>
            <td>"I used to have a dog" - Not selected</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E3</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>I've never had a dog is exclusive</p>
        </div>
    `,

	E2: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>"Less than 12 months ago"</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E2_1</td>
            </tr>
            <tr>
            <td>Other options</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E3</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E2_1: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E3</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E3: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>Yes actively looking</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E4</td>
            </tr>
            <tr>
            <td>Yes in the future</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E3_1</td>
            </tr>
            <tr>
            <td>No</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E3_2</td>
            </tr>
            <tr>
            <td>Don't know / Prefer not to say / No Answer</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E6</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E3_1: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E4</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E3_2: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E6</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E4: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E4_1</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E4_1: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E4_2</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E4_2: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E5</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E5: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>If they DON'T select UK based rehoming centre</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E5_1</td>
            </tr>
            <tr>
            <td>If they DO select UK based rehoming centre</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E6</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E5_1: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E6</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E6: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E7</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E7: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>If they DID select Fostering</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E7_1</td>
            </tr>
            <tr>
            <td>If they DID NOT select Fostering</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E8</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E7_1: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E8</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E8: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>THOUGHTS_ON_DOGS</td>
            <td>E9</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,

	E9: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>ABOUT_YOU</td>
            <td>AY_INTRO_0</td>
            </tr>
        </table>
        <h5>Other info</h5>
        </div>
    `,
};
